/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Browser Updated.
 * @export
 */
export const ICON_BROWSER_UPDATED = (
  <svg fill="none" height="16" viewBox="0 0 17 16" width="17" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.1673 8.66667V10.6667C15.1673 11.4 14.5673 12 13.834 12H11.834L12.5007 12.6667V14H4.50065V12.6667L5.16732 12H3.16732C2.43398 12 1.83398 11.4 1.83398 10.6667V3.33333C1.83398 2.6 2.43398 2 3.16732 2H8.50065V3.33333H3.16732V10.6667H13.834V8.66667H15.1673ZM10.5007 10L7.16732 6.66667L8.10732 5.72667L9.83398 7.44667V2H11.1673V7.44667L12.894 5.72667L13.834 6.66667L10.5007 10Z"
      fill="#707070"
    />
  </svg>
);
